import { api } from 'common';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockRunModeField } from '../../ConfigFields/RunMode';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

const mockScenarioIdOptions = [
  { label: 'SR-CreateRequestError-i', value: 'SR-CreateRequestError-i' },
  { label: 'SR-GetComplete-i', value: 'SR-GetComplete-i' },
  { label: 'SR-GetInProgress-i', value: 'SR-GetInProgress-i' },
  { label: 'SR-GetPayerDown-i', value: 'SR-GetPayerDown-i' },
];

export function AuthorizationSubmissionFormFields() {
  const { value: runMode } =
    useSelectedNodeField<api.FlowDefinition.AuthorizationSubmissionBlock['config']['runMode']>(
      'config.runMode'
    );
  return (
    <>
      <BlockRunModeField
        fieldName="config.runMode"
        label="Test Mode"
        helperText="Specify settings to test an authorization submission."
      />
      {runMode === api.FlowDefinition.RunMode.Test && (
        <>
          <BlockSelectField
            label="Mock Scenario Id"
            fieldName="config.mockScenarioId"
            options={mockScenarioIdOptions}
            helperText="Request a mocked canned response from Availity API. Refer to Service Reviews demo response scenarios at https://developer.availity.com/partner/documentation#c_service_reviews."
          />
          <BlockValueTemplateField
            fieldName="config.patientLastName"
            label="Patient Last Name"
            helperText="Pass in test patient last name if it contains a flag that maps to a mock Availity response"
          />
        </>
      )}
    </>
  );
}
